import React from 'react';
import {useSurveyContext} from "../../../context/SurveyContext";
import TextInputWithLabel from "../../TextInputWithLabel";

function TextQuestion(props) {
    const {survey: {answers}, setAnswer} = useSurveyContext();
    const answer = answers[props.question.id] || "";

    const isShown = props.question.part === props.activePart;

    return (
        <div className={isShown ? "" : "hidden"}>
            <TextInputWithLabel
                label={props.question.questionText}
                subLabel={props.question.questionInfo}
                subLabelClasses="text-grey-darker"
                value={answer}
                _onChange={value => setAnswer(props.question.id, value)}
                onBlur={() => props.validate(props.question, answer)}
                placeholder=""
                labelClassNames="input-label"
            />
        </div>
    )
}

export default TextQuestion;